import { useEffect, useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { ErrorMessage, Form, Formik } from 'formik'
import Button from '../../../components/button/Button'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH } from '../../../utility/constants'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { exportStudentReport, generateDropdownOptions, convertTZToDate } from '../../../utility/genricFunction'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import './studentDetailsReport.scss'
import { getBatchFromBranch, getStudentDetailsReport } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'

function StudentDetailsReport() {

    const dispatch = useDispatch();
    const reportData = useSelector((store) => store.reports.studentDetailsReportData);
    const {loading,pageDropDownLoading} = useSelector((store) => store.reports);

    const batches = useSelector((store) => store.reports.batches);
    const batchOptions = useMemo(() => generateDropdownOptions(batches, 'batchNo', 'batchId'), [batches]);

    const branches = useSelector((state) => state?.branch?.branchTableData);
    const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches]);

    const userRole = useSelector((state) => state.auth?.user?.result?.userData?.roleName) || {}
    const branchId = useSelector((state) => state.auth?.user?.result?.userData?.branchId)

    const [branch, setBranch] = useState("");
    const [batch, setBatch] = useState("");
    const [isTableOpen, setIsTableOpen] = useState(false);

    const [initialValues] = useState({
        branch: userRole == "branch" ? branchId : '',
        batch: ''
    })

    useEffect(() => {
        // dispatch(getBranch('active'));

        if (userRole == "branch") {
            dispatch(getBatchFromBranch(branchId))
        }
    }, []);

    const validationSchema = Yup.object().shape({
        branch: Yup.string()
            .required(VALIDATION_MESSAGES.BRANCH_FORM.BRANCH_NAME_REQUIRED),
        batch: Yup.string()
            .required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    });

    function handleFormSubmit(values) {
        setBranch(values.branch);
        setBatch(values.batch);
        setIsTableOpen(true);

        const data = {
            branch: values.branch,
            batch: values.batch
        };

        dispatch(getStudentDetailsReport(data));
    }

    const handleBranchChange = (value, setFieldValue) => {
        setFieldValue("branch", value);
        dispatch(getBatchFromBranch(value));
    }

    const breadCrumbsArr = [
        {
            title: 'Student details',
            link: null,
        },
        {
            title: 'Dashboard',
            link: ROUTES_PATH.DASHBOARD,
        },
        {
            title: 'Student Details',
            link: ROUTES_PATH.STUDENT_DETAILS_REPORT,
        },
    ];

    const printRef = useRef()

    const handleDownloadPfd = useReactToPrint({
        content: () => printRef.current,
    });
    

    const dateBody = (reporData) => {
        const representative = reporData?.enrollmentDate && convertTZToDate(reporData?.enrollmentDate)
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        );
    }

    const birthDateBody = (reporData) => {
        const representative = reporData?.birthDate && convertTZToDate(reporData?.birthDate)
        return (
            <div className='flex align-items-center gap-2'>
                <span>{representative}</span>
            </div>
        );
    }

    const columns = [
        {
            field: 'no',
            header: "#",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '3rem' },
        },
        {
            field: 'studentCode',
            header: "Code",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'studentName',
            header: "Student Name",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'enrollmentDate',
            header: "Reg. Date",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '6rem' },
            body: dateBody
        },
        {
            field: 'birthDate',
            header: "Birth Date",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '6rem' },
            body: birthDateBody
        },
        {
            field: 'studentPhone',
            header: "Phone",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'parentPhone',
            header: "Parent Phone",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '8rem' },
        },
        {
            field: 'email',
            header: "Email ID",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '12rem' },
        },
        {
            field: 'totalFees',
            header: "Total Fees",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
        {
            field: 'paidAmount',
            header: "Paid",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
        {
            field: 'pendingAmount',
            header: "Pending",
            filter: false,
            filterDisplay: 'row',
            style: { minWidth: '2rem' },
        },
    ];


    return (
        <>
        {loading && <Loader loading={loading} />}
        {<Loader loading={loading} /> && <div className='studentDetailsReport-wrapper'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    handleFormSubmit(values);
                }}
                enableReinitialize
            >
                {({ values, handleChange, handleSubmit, setFieldValue }) => (
                    <Form>
                        <div className='studentDetailsReport-header'>
                            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                        </div>

                        <div className='studentDetailsReport'>
                            <div className='studentDetailsReport-input-fields'>
                                <div className='studentDetailsReport-input'>
                                    <label htmlFor=''>
                                        Branch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={branchOption}
                                        selectedValue={values.branch}
                                        className={'studentDetailsReport-dropdown'}
                                        onChange={(e) => handleBranchChange(e.target.value, setFieldValue)}
                                        name={'branch'}
                                        placeholder={'Select Branch'}
                                        disabled={userRole == "branch"}
                                    />
                                    <ErrorMessage name='branch' component='div' className='error-msg' />
                                </div>

                                <div className='studentDetailsReport-input'>
                                    <label htmlFor=''>
                                        Batch<span className='required-symbol'>*</span>
                                    </label>
                                    <PageDropdown
                                        loading={pageDropDownLoading}
                                        options={batchOptions}
                                        selectedValue={values.batch}
                                        className={'studentDetailsReport-dropdown'}
                                        onChange={handleChange}
                                        name={'batch'}
                                        placeholder={'Select Batch'}
                                    />
                                    <ErrorMessage name='batch' component='div' className='error-msg' />
                                </div>

                                <div className='report-submit-div'>
                                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>

            {isTableOpen && (
                <div className='studentDetailsReport-table'>
                    <div className='export-option-wrapper'>

                        <div className='pdf-excel-export'>
                            <Button
                                text={'Export'}
                                type={'button'}
                                onClick={() =>
                                    exportStudentReport(reportData, 'Student Details Report', 'StudentDetailsReport.xlsx')
                                }
                                disabled={reportData?.length > 0 ? false : true}
                            >
                                <SimCardDownloadIcon />
                            </Button>

                            <Button text={'Export'}
                                type={'button'} 
                                onClick={handleDownloadPfd} 
                                disabled={reportData?.length > 0 ? false : true}>
                                <PrintIcon />
                            </Button>
                        </div>
                    </div>

                    <div className='printable-component' ref={printRef}>
                        <ReportDataTable
                            columns={columns}
                            value={reportData}
                            loading={loading}
                        />
                    </div>


                </div>
            )}
        </div>}
        </>
    );
}

export default StudentDetailsReport;
